import { transformFleetVehicle } from "../../transformations";
import { transformVehicleLocation } from "../transformations";
import { VehicleTransferRow } from "./types";

export const transformVehicleTransferRow = (res: any): VehicleTransferRow => ({
  vehicle: res.vehicle ? transformFleetVehicle(res.vehicle) : null,
  location: res.location ? transformVehicleLocation(res.location) : null,
});
